import React from 'react';
import './ImageContainer.css';

function ImageContainer({ 
  src, 
  alt, 
  rounded = false, 
  overlay = false, 
  rotate = 0,
  offsetX = 0,
  aspectRatio = 'auto',
  maxWidth = '100%',
  className = ''
}) {
  const containerClasses = [
    'image-container',
    rounded ? 'image-container-rounded' : 'image-container-square',
    aspectRatio === '1/1' ? 'image-container-square-ratio' : '',
    className
  ].filter(Boolean).join(' ');

  const style = {
    maxWidth,
    aspectRatio: aspectRatio !== 'auto' ? aspectRatio : undefined,
    transform: `rotate(${rotate}deg) translateX(${offsetX}px)`,
    transition: 'all 0.3s ease'
  };

  return (
    <div className={containerClasses} style={style}>
      <img 
        src={src}
        alt={alt}
        className="image-container-img"
      />
      {overlay && <div className="image-overlay"></div>}
    </div>
  );
}

export default ImageContainer;

